var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.tag)?_c('regular-icon',{attrs:{"file_name":_vm.file.name}}):_c('tag-icon',{attrs:{"file_id":_vm.file.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }